var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Select as ChakraReactSelect } from "chakra-react-select";
import { FormControl, FormLabel, FormErrorMessage, FormHelperText } from "@chakra-ui/react";
/** This component is a wrapper around Select component chakra-react-select
 * Which is wrapper around Select component of react-select package
 * This component supports all the props of both the packages
 * react-select : https://www.npmjs.com/package/react-select,
 * chakra-react-select: https://www.npmjs.com/package/chakra-react-select
 */
export const Select = (props) => {
    const { errorMessage, helpText, id, isInvalid, isMulti, isRequired, label, labelKey = "label", name, onBlur = () => { }, onChange, options, value, valueKey = "value" } = props, relatedProps = __rest(props, ["errorMessage", "helpText", "id", "isInvalid", "isMulti", "isRequired", "label", "labelKey", "name", "onBlur", "onChange", "options", "value", "valueKey"]);
    const selectedValue = useMemo(() => {
        if (Array.isArray(value)) {
            return value.length > 0
                ? options.filter((option) => value.includes(option[valueKey]))
                : [];
        }
        return value ? options.find((option) => option[valueKey] === value) : undefined;
    }, [value, options]);
    const onChangeMethod = (selectedOption) => {
        const target = {
            name,
            label: "",
            value: "",
        };
        if (Array.isArray(selectedOption)) {
            target.label = selectedOption.map((eachOption) => eachOption[labelKey]);
            target.value = selectedOption.map((eachOption) => eachOption[valueKey]);
        }
        else if (selectedOption) {
            target.label = selectedOption[labelKey];
            target.value = selectedOption[valueKey];
        }
        onChange({ target });
    };
    const onBlurMethod = () => {
        onBlur({ target: { name } });
    };
    const getOptionLabel = (option) => {
        return option[labelKey];
    };
    const getOptionValue = (option) => {
        return option[valueKey];
    };
    return (_jsxs(FormControl, { isInvalid: isInvalid, isRequired: isRequired, id: id, children: [label && _jsx(FormLabel, { children: label }), _jsx(ChakraReactSelect, Object.assign({ value: selectedValue, options: options, onChange: onChangeMethod, isMulti: isMulti, closeMenuOnSelect: !isMulti, id: `${id}-select`, classNamePrefix: "react-select", getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isInvalid: isInvalid, onBlur: onBlurMethod }, relatedProps)), errorMessage && _jsx(FormErrorMessage, { children: errorMessage }), helpText && _jsx(FormHelperText, { children: helpText })] }));
};
//# sourceMappingURL=select.js.map